import {
	ADMINGETFEEMAPPING_SUCCESS,
	ADMINGETFEEMAPPING_FAILED,
	RESET_ADMINGETFEEMAPPING,
	LOADING_ADMINGETFEEMAPPING,
	NETWORK_ERROR_ADMINGETFEEMAPPING
} from "../types/index";

const initialState = {
	isLoading: false,
	success: false,
	network: false,
	failed: false,
	data: {}
};

export default (state = initialState, action) => {
	switch (action.type) {
		case LOADING_ADMINGETFEEMAPPING:
			return {
				...state,
				isLoading: true,
				success: false,
				failed: false,
				network: false,
				data: {}
			};
		case ADMINGETFEEMAPPING_FAILED:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: true,
				network: false,
				data: action.payload
			};
		case ADMINGETFEEMAPPING_SUCCESS:
			return {
				...state,
				isLoading: false,
				success: true,
				failed: false,
				network: false,
				data: action.payload
			};
		case NETWORK_ERROR_ADMINGETFEEMAPPING:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: false,
				network: true,
				data: {}
			};
		case RESET_ADMINGETFEEMAPPING:
			return (state = initialState);
		default:
			return state;
	}
};
